import React from "react";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteGlobalWorkbenchCartButton = React.lazy(
    () => import("adsMagnetoMfc/GlobalWorkbenchCartButton"),
) as React.FC<any>;

export const GlobalWorkbenchCartButton: React.FC<any> = (props) => {
    return (
        <RemoteComponentWrapper>
            <RemoteGlobalWorkbenchCartButton {...props} />
        </RemoteComponentWrapper>
    );
};
